export default __webpack_public_path__ + "pp-logo.988b9685.svg";